import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=2dce826f"
import script from "./TableActions.vue?vue&type=script&lang=ts"
export * from "./TableActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports